import { useMemo } from 'react'

import { filterTours } from '../utilities/filters/filterTours'

export function useFilterTours(tours, filterState, isDestinationPage) {
  return useMemo(
    () => filterTours(tours, filterState, isDestinationPage),
    [tours, filterState, isDestinationPage],
  )
}
